﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { CCRPSMToken, CCRPStatusMonitoring, CCRPDayToken, DailyTokenItem, DailyToken, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ModalDirective } from "ngx-bootstrap";
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-ccrp-stat-mon',
  templateUrl: './ccrp-stat-mon.component.html',
  styleUrls: ['./ccrp-stat-mon.component.css']
})
export class CcrpStatMonComponent implements OnInit {

  
  currMonthDtObj:Date = new Date();
  areChangesMade: boolean = false;
  

  datatables:CCRPStatusMonitoring;

  isFullScrDaySel:boolean = true;
  selectedDayIndex:number = 0; 
  daywiseItemList: Array<DailyToken>;
  
  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';

  mId:string = "75d6c01a-ca1e-4bf2-6a07-496509cba968";
  hasmodaccess:boolean = false;
  ccrpDayTokenObj:CCRPDayToken;
  selView:number=1;
  editHeader: string ="";
  generateExcelFromDate:any;
  generateExcelToDate:any;

@ViewChild('childModal') public childModal:ModalDirective; 
@ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

constructor(private _dataService:DataService, private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "CCRP Status Monitoring";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
    });
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }

  changesMade(flag:boolean){
    this.areChangesMade = flag;
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade= false;
  
    this._dataService.loadCCRPStatusMonitoring(this.currMonthDtObj).subscribe((_cstInspPlan:CCRPStatusMonitoring) => {
        if(_cstInspPlan!=null){
        this.datatables = _cstInspPlan;
        this.loadDateData();
        
        let _tmpDailyTokenList: Array<DailyToken> = [];
        for (var i = 0; i < this.datatables.dayTokens.length; i++) {
          let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
          let _tmpDailyTokens:Array<DailyTokenItem> = [];            
          let _indexer:number = 0;
          this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:CCRPSMToken) => {
            _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.materialDesc,0), this.getIdObj(_tmpDate,_indexer),''));
            _indexer++;
          });
          _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
        }

        this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
        }
        else{
          this.daywiseItemList = null
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }

  private getDisplayTokenName(_custId:string,_quantity:number){
    if(_custId){
      return _custId ;
    }
    else{
      return '---'
    }
    
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
 

  

  

  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-MM-YYYY");
    }
    return '-';
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  getData(option){
    if(option) return option
    return ''
  }
  getResponsiblePrsn(_prsn:string):string{
    if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
    return ''
  }

  
  discardData():void{
    this.loadMonthData();
  }
 

  validateData():boolean{
    return true;
  }
  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this._dataService.saveCCRPStatusMntring(this.datatables, _sendMail)
        .subscribe((resp: GenResponse) => {
          if (resp.status == DataService.statusFail) {
            if (resp.errorCode == DataService.staleDataCode) {
              this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
            } else {
              this._notify.error('Failure', resp.details, this._dataService.failureOptions);
            }
          }
          else {
            this._notify.success('Success', resp.details, this._dataService.successOptions);
            this.loadMonthData();
          }
        });
    }
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }
  public prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  
  loadDateData():void{
    let _tmpDPHDayToken:CCRPDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj,null,null,null,null,null,null);  
      _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
    this.ccrpDayTokenObj = _tmpDPHDayToken;
  }
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  exportToExcel(){
    var startDate = new Date(this.generateExcelFromDate);
    var endDate  = new Date(this.generateExcelToDate);
    if(this.validateStartEndDate(startDate,endDate)){
        this._dataService.downloadFile(startDate,endDate,"CCRP");
        this.hideChildModal();
    }
  }
  
  validateStartEndDate(_startDate:Date,_endDate:Date):boolean{
    if(_startDate > _endDate){
      this._notify.error('Failure','Invalid Date',this._dataService.failureOptions);
      return false;
    }

    return true;
  }
  
  showExportModel(){
    this.editHeader = "Export To Excel";
    this.generateExcelFromDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
    this.generateExcelToDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
    this.childModal.show();

  }

  hideChildModal(){
     this.childModal.hide();
  }
}
